import { useEffect, useRef, useState } from 'react';
import { GoogleMap, Marker } from '@react-google-maps/api';
import { googleMapsStylesLight } from '../../Map/googleMapStyles';
import { IExpressDelivery, IGuide } from '../../../interfaces/express-delivery.interface';
import { IMAGES } from '../../../const/images';

interface Props {
    itemSelected: IGuide;
}

const ContainerMap = ({ itemSelected }: Props) => {
    const [markers, setMarkers] = useState<{ lat: number; lng: number }[]>([]);
    const [pickupCoordinates, setPickupCoordinates] = useState<{ lat: number; lng: number }>({ lat: 0, lng: 0 });

    const mapRef = useRef<google.maps.Map | null>(null);

    const onLoad = (map: google.maps.Map) => {
        const bounds = new window.google.maps.LatLngBounds();
        bounds.extend(pickupCoordinates);
        markers.forEach((marker) => bounds.extend(marker));
        map.fitBounds(bounds);
        mapRef.current = map;
    };

    const getPickupCoordinates = (firstItem: IExpressDelivery) => {
        if (firstItem.pickupCoordinates?.coordinates?.length >= 2) {
            const coords = {
                lat: firstItem.pickupCoordinates.coordinates[1] || 0,
                lng: firstItem.pickupCoordinates.coordinates[0] || 0,
            };
            setPickupCoordinates(coords);
        }
    };

    const createNumberedMarker = (number: number) => {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        const size = 30;

        canvas.width = size;
        canvas.height = size;

        if (ctx) {
            ctx.beginPath();
            ctx.arc(size / 2, size / 2, size / 2 - 2, 0, 2 * Math.PI);
            ctx.fillStyle = '#00B2E3'; // Color cyan
            ctx.fill();
            ctx.strokeStyle = '#ffffff';
            ctx.lineWidth = 2;
            ctx.stroke();

            ctx.fillStyle = '#ffffff';
            ctx.font = 'bold 14px Arial';
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';
            ctx.fillText(number.toString(), size / 2, size / 2);
        }

        return canvas.toDataURL();
    };

    useEffect(() => {
        if (!itemSelected) return;

        const firstDelivery = itemSelected.expressDeliveries[0] as IExpressDelivery;
        getPickupCoordinates(firstDelivery);

        const validMarkers = itemSelected.expressDeliveries.map((delivery) => ({
            lat: delivery.deliveryCoordinates?.coordinates[1] || 0,
            lng: delivery.deliveryCoordinates?.coordinates[0] || 0,
        }));

        setMarkers(validMarkers as { lat: number; lng: number }[]);
    }, [itemSelected]);

    return (
        <div style={{ height: '100%', width: '100%' }}>
            <GoogleMap
                id="map"
                onLoad={onLoad}
                mapContainerStyle={{ height: '100%', width: '100%' }}
                options={{ styles: googleMapsStylesLight }}
                zoom={10}
            >
                <Marker
                    position={pickupCoordinates}
                    icon={{
                        url: IMAGES.icons.store_location,
                        scaledSize: new window.google.maps.Size(40, 40),
                    }}
                />
                {markers.map((marker, index) => (
                    <Marker
                        key={`marker-${index}`}
                        position={marker}
                        icon={{
                            url: createNumberedMarker(index + 1),
                            scaledSize: new window.google.maps.Size(35, 35),
                        }}
                    />
                ))}
            </GoogleMap>
        </div>
    );
};

export default ContainerMap;
